import MaintenanceFeeConfirmation from './MaintenanceFeeConfirmation.vue'
export default MaintenanceFeeConfirmation


// WEBPACK FOOTER //
// ./src/pages/MaintenanceFeeConfirmation/index.js